import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderByGroup'
})
export class OrderByGroupPipe implements PipeTransform {

 transform(array, orderBy, sort){

     if (!orderBy || orderBy.trim() == ""){
       return array;
     }

     //ascending
     if (sort == 'asc'){
       return Array.from(array).sort((item1: any, item2: any) => {
         return this.orderByComparator(item1[orderBy], item2[orderBy]);
       });
     }
     else{
       //not asc
       return Array.from(array).sort((item1: any, item2: any) => {
         return this.orderByComparator(item2[orderBy], item1[orderBy]);
       });
     }

 }

 orderByComparator(a:any, b:any):number{

     if (!a) a = 0;
     if (!b) b = 0;
     if((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
       //Isn't a number so lowercase the string to properly compare
       if(a.toLowerCase() < b.toLowerCase()) return -1;
       if(a.toLowerCase() > b.toLowerCase()) return 1;
     }
     else{
       //Parse strings as numbers to compare properly
       if(parseFloat(a) < parseFloat(b)) return -1;
       if(parseFloat(a) > parseFloat(b)) return 1;
      }

     return 0; //equal each other
 }

}



// WEBPACK FOOTER //
// ./src/app/order-by-group.pipe.ts